module.exports = __webpack_public_path__ + "static/media/RW.b586ef69.svg";